import { branch, compose, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { getProcessing } from '../selectors';
import ProcessingIndicator from '../components/ProcessingIndicator';

const ProcessingIndicatorContainer = compose(
  connect(
    state => ({
      processing: getProcessing(state),
    }),
  ),
  branch(
    props => !props.processing,
    renderNothing,
  ),
)(ProcessingIndicator);

export default ProcessingIndicatorContainer;



// WEBPACK FOOTER //
// ./src/app/reservation/containers/ProcessingIndicator.js